var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"centerx"},_vm._l((_vm.mailContent.answer.options),function(item,index){return _c('li',{key:index},[_c('vs-checkbox',{attrs:{"vs-value":item.name},model:{value:(_vm.followup),callback:function ($$v) {_vm.followup=$$v},expression:"followup"}},[_vm._v(_vm._s(item.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }